// Implements: F-UIX-019, F-GEN-036
/**
 * The sentence of a settings source (`env`, `panel`). The server may one day name another one:
 * it is then shown as written, never looked up by an inherited property name.
 */

import type { SettingsSource } from "../../../types/modelSettings";

const SOURCE_LABELS = {
  env: "admin.modelSettings.source.env",
  panel: "admin.modelSettings.source.panel",
} as const satisfies Record<SettingsSource, string>;

/** The dictionary key of a source the panel knows, or `null`. */
export function sourceKey(source: string): (typeof SOURCE_LABELS)[SettingsSource] | null {
  return Object.hasOwn(SOURCE_LABELS, source) ? SOURCE_LABELS[source as SettingsSource] : null;
}
